module.exports = __webpack_public_path__ + "media/images/vector-120@2x-ddd57a9b3961d4cdc150bc55e14bba69.png";